export default function getBrowserType() {
    const UserAgent = navigator.userAgent.toLowerCase();
    if (window.ActiveXObject || "ActiveXObject" in window) return 'IE';
    if (UserAgent.indexOf('opera') > -1 || UserAgent.indexOf('opr') > -1) return 'Opera';
    if (UserAgent.indexOf('edge') > -1 || UserAgent.indexOf('edg') > -1) return 'Edge';
    if (UserAgent.indexOf('safari') > -1 && UserAgent.indexOf('chrome') == -1) return 'Safari';
    if (/qqbrowser/.test(UserAgent)) return 'QQ浏览器';
    if (/MicroMessenger/i.test(UserAgent)) return '微信浏览器';
    if (UserAgent.indexOf("qihoobrowser") > -1 || UserAgent.indexOf("qhbrowser") > -1) return '360浏览器';
    if (UserAgent.indexOf('chrome') > -1 && UserAgent.indexOf('safari') > -1) return 'Chrome';
    if (UserAgent.indexOf('firefox') > -1) return 'Firefox';
    return ''
}